export default __webpack_public_path__ + "static/media/hechunshui.ba753f1f.jpg";